import { gql } from 'graphql-request'
import { botApi } from '@client/client'
import { BotMarketType } from '@interfaces/BotMarketEnum'

export const turnOnOffAllBotApi = botApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    turnOnOffAllBot: builder.mutation<
      boolean,
      { isTurnOn: boolean; botMarketType: BotMarketType }
    >({
      query: ({ isTurnOn, botMarketType }) => ({
        document: gql`
          mutation TurnOnOffAllBot(
            $isTurnOn: Boolean!
            $botType: BotType!
            $botMarketType: BotMarketType!
          ) {
            turnOnOffAllBot(
              isTurnOn: $isTurnOn
              botType: $botType
              botMarketType: $botMarketType
            )
          }
        `,
        variables: {
          botType: 'Martingale',
          isTurnOn,
          botMarketType,
        },
      }),
    }),
  }),
})

export const { useTurnOnOffAllBotMutation } = turnOnOffAllBotApi
